// extracted by mini-css-extract-plugin
module.exports = {"filters":"_3FdkSE0cif5SLre2vy3R8n","filterLabel":"_3GTohmB6HfToFnYHJjwNrF","filterLabelIcon":"_2SzoDS4YS-1wav-CoUDHn7"};